import React, { useState, useEffect, useMemo } from 'react';
import {
  Widget,
  GridView,
  SimpleView,
  Table,
  Button,
  ButtonDelete,
  MasterDetailForm,
  FormInput,
  notification,
  FormTextArea,
  Icon
} from '@digital/ui';
import FiltrosPcs from './FiltrosPcs';
import {
  Filter,
  CtrPcsResultData,
  obterNarativaPorOrdemInvestimentoRequisicaoCompraSeqId,
  getAllRequisitadoOcData,
} from '../../api/ctrPcs';
import { Collapse, Icon as IconAntD, Input, Tooltip } from 'antd';
import { getAllProjetoOrdemInvestimento, ProjetoOrdemInvestimento } from '@app/api/projeto';
import { ChangeEvent } from 'react';
import {
  DistribuicaoRequisitado,
  RequisitadoAno,
  getAllRequisitadoAno,
  atualizarValorRequisitadoAno,
  deleteRequisitadoAno,
  adcionarColunaItemRateavelRequisitadoAno,
  adcionarLinhaItemRateavelRequisitadoAno,
  concluirRateioOcRc
} from '../../api/requisitadoOc';
import { Notifications } from '@app/api/api';
import Narativa from '@app/components/Narativa';
import { hasPermission } from '@app/helpers/permissions';



const RequisitadoOc = () => {
  const { Panel } = Collapse;

  const [resultPesquisa, setResultConsult] = useState<CtrPcsResultData[]>();
  const [resultadoSelecionado, setResultadoSelecionado] = useState<string>();
  const [distribuicaoItemSelecionado, setdistribuicaoItemSelecionado] = useState<RequisitadoAno>();
  const [resultContratadoAno, setResultContratadoAno] = useState<RequisitadoAno[]>();
  const [resultDistribuicao, setDistribuicao] = useState<DistribuicaoRequisitado>();
  const [selectionOrdemInvestimento, setSelectionOrdemInvestimento] = useState<ProjetoOrdemInvestimento>();
  const [resultProjetoOrdemInvestimento, setProjetoOrdemInvestimento] = useState<ProjetoOrdemInvestimento[]>();
  const [imputTextoNarativa, setImputTextoNarativa] = useState<string>('');
  const [imputProjeto, setImputProjeto] = useState<string>('');
  const [imputPacoteOi, setImputPacoteOi] = useState<string>('');
  const [editavel, setEditavel] = useState<boolean>(false);
  const [idEdit, setidEdit] = useState<string>('');
  const [quantidadeAnoEdit, setQuantidadeAnoEdit] = useState<string>('');
  const [enableBtnsRateio, setEnableBtnsRateio] = useState<boolean>(false);
  const [displayWidgetNovaLinha, setDisplayWidgetNovaLinha] = useState({ display: 'none' });
  const [displayWidgetResultado, setDisplayWidgetResultado] = useState({ display: 'none' });
  const [displayWidgetTabelaDistribuicao, setDisplayWidgetTabelaDistribuicao] = useState({ display: 'none' });
  const [btnAdcionarLinhaSelecionado, setBtnAdcionarLinhaSelecionada] = useState<boolean>(true);


  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      if (selectedRows) {
        setResultadoSelecionado(selectedRowKeys);
      } else {
        setResultadoSelecionado('');
      }
    },
    getCheckboxProps: (record: { name: any; }) => (
      {
        disabled: record.name === 'Disabled User',
        name: record.name,
      }),
    selectedRowKeys: resultadoSelecionado,
    type: 'radio'
  };

  const rowSelectionTableDistribuicao = {
    onChange: (selectedRowKeys: string, selectedRows: RequisitadoAno[]) => {
      if (selectedRowKeys) {
        setdistribuicaoItemSelecionado(selectedRows[0]);
      } else {
        setdistribuicaoItemSelecionado({} as RequisitadoAno);
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: distribuicaoItemSelecionado != undefined ? distribuicaoItemSelecionado.ordemInvestimentoRequisicaoCompraSeqId : '',
    type: 'radio'
  };

  const rowSelectionOrdemInvestimento = {
    onChange: (selectedRowKeys: string, selectedRows: ProjetoOrdemInvestimento[]) => {
      if (selectedRows) {
        setSelectionOrdemInvestimento(selectedRows[0]);
      } else {
        setSelectionOrdemInvestimento({} as ProjetoOrdemInvestimento);
      }
    },
    getCheckboxProps: (record: { name: any; }) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
    selectedRowKeys: selectionOrdemInvestimento != undefined ? selectionOrdemInvestimento.ordemInvestimentoId : '',
    type: 'radio'
  };

  const handleFilter = (values: Filter) => {
    getAllRequisitadoOcData(values).then(data => {
      if (data) {
        limparCamposTela();
        setDisplayWidgetResultado({ display: 'block' });
        setResultConsult(data as CtrPcsResultData[]);
        setdistribuicaoItemSelecionado({} as RequisitadoAno);
      }
    });
  };

  const iniciarValores = () => {
    setProjetoOrdemInvestimento([]);
    setResultContratadoAno([]);
    setdistribuicaoItemSelecionado({} as RequisitadoAno);
    setDisplayWidgetNovaLinha({ display: 'none' });
    setEnableBtnsRateio(false);
    setImputTextoNarativa('');
    setDisplayWidgetTabelaDistribuicao({ display: 'none' });
    setSelectionOrdemInvestimento({} as ProjetoOrdemInvestimento);
    setBtnAdcionarLinhaSelecionada(false);
  }

  const atualizarTabela = useMemo(() => {
    iniciarValores();
  }, [resultadoSelecionado]);

  const limparCamposTela = () => {
    setResultConsult([]);
    setResultadoSelecionado('');
    iniciarValores();
    setDisplayWidgetResultado({ display: 'none' });
  };


  const cancelar = () => {
    setEditavel(false);
    setidEdit('');
  };

  const eventoClickImput = (event: ChangeEvent<HTMLInputElement>, recorder: RequisitadoAno, quantidadeAno: string) => {
    setEditavel(true);
    setidEdit(recorder.ordemInvestimentoRequisicaoCompraSeqId);
    setQuantidadeAnoEdit(quantidadeAno);
  };

  const salvar = (
    recorder: RequisitadoAno,
    event: ChangeEvent<HTMLInputElement>,
    valorAlterado: string,
    ano: string,
  ) => {
    atualizarValorRequisitadoAno(
      recorder.ordemInvestimentoRequisicaoCompraSeqId,
      valorAlterado,
      ano,
    ).then(data => {
      AtualizarTablelaContratoAno();
      setEditavel(false);
      setidEdit('');
    });
  };

  const columsDistribuicaoItem = useMemo(() => {
    const colluns = [];

    colluns.push({
      title: 'PACOTE',
      key: 'PACOTE',
      children: [
        {
          title: 'Projeto',
          dataIndex: 'pacoteProjeto',
        },
        {
          title: 'PCT/OI',
          dataIndex: 'pacotePctOi',
        },
      ],
    });

    colluns.push({
      title: 'REQUISIÇÃO DE COMPRA',
      key: 'REQUISICAODECOMPRA',
      children: [
        {
          title: 'Numero',
          dataIndex: 'requisicaoCompraNumero',

        },
        {
          title: 'SEQ',
          dataIndex: 'requisicaoCompraSeq',

        },
        {
          title: 'PREÇO UNITÁRIO',
          dataIndex: 'requisicaoCompraPrecoUnitarioFormatado',

        },
        {
          title: 'QTD',
          dataIndex: 'quantidadeFormatado',

        },
        {
          title: 'VALOR',
          dataIndex: 'requisicaoCompraValorTotalFormatado',

        },
        {
          title: 'OC',
          dataIndex: 'requisicaoCompraOc',

        },
      ],
    });

    if (resultDistribuicao) {
      const distrubuicao = resultDistribuicao as DistribuicaoRequisitado;
      let colunasAnos:
        {
          title: string;
          dataIndex: string;
          width: string;
          children: (
            {
              title: string;
              dataIndex: string; key:
              string; render: (text: any, record: any, index: any) => JSX.Element;
            } | { title: string; dataIndex: string; key: string; render?: undefined; })[];
        }[] = [];

      distrubuicao.anos.map(ano => {
        colunasAnos.push({
          title: `${ano}`,
          dataIndex: `${ano}`,
          width: '',
          children: [
            {
              title: 'QTD',
              dataIndex: `quantidade${ano}`,
              key: `quantidade${ano}`,
              render: (text, record, index) => {
                if (hasPermission(['MODULO_REQUISITADO_ALTERAR_INCLUIR_DELETAR'])) {
                  if (
                    editavel &&
                    idEdit === record.ordemInvestimentoRequisicaoCompraSeqId &&
                    quantidadeAnoEdit === `${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`
                  ) {
                    return (
                      <Input
                        id={`${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`}
                        name={`${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`}
                        onBlur={() => {
                          cancelar();
                        }}
                        onPressEnter={e => {
                          const evento = e as unknown as ChangeEvent<HTMLInputElement>;
                          salvar(record, evento, record[`quantidade${ano}`], `${ano}`);
                        }}
                        defaultValue={record[`quantidadeInicial${ano}`]}
                        onChange={e => {
                          record[`quantidade${ano}`] = e.target.value;
                        }}
                      />
                    );
                  } else {
                    return (
                      <div
                        className="editable-cell-value-wrap"
                        style={{ paddingRight: 24 }}
                        onClick={e => {
                          const evento = e as unknown as ChangeEvent<HTMLInputElement>;
                          eventoClickImput(evento, record, `${record.ordemInvestimentoRequisicaoCompraSeqId}quantidade${ano}`)
                        }
                        }>
                        {<> {record[`quantidadeInicial${ano}`]} </>}
                      </div>
                    );
                  }

                } else {
                  return <> {record[`quantidadeInicial${ano}`]} </>
                }
              },
            },
            {
              title: 'Valor',
              dataIndex: `valorFormatado${ano}`,
              key: `valorFormatado${ano}`,
            },
          ],
        });
      });
      if (colunasAnos.length > 0) {
        colluns.push({
          title: 'RATEIO',
          key: 'RATEIO',
          children: colunasAnos,
        });
      }
    }

    return colluns;
  }, [resultDistribuicao, editavel, idEdit]);

  const columsRequisicaoCompraSeq = [
    {
      title: 'PACOTE /OI',
      key: 'pacoteOi',
      children: [
        {
          title: 'N',
          dataIndex: 'row',
          width: '1%',
        },
        {
          title: 'Código',
          dataIndex: 'pacoteOiCodigo',
          width: '',
        },
        {
          title: 'Nome',
          dataIndex: 'pacoteOiNome',
          width: '',
        },
        {
          title: 'OI',
          dataIndex: 'pacoteOiOi',
          width: '',
        },
        {
          title: 'PROJETO',
          dataIndex: 'pacoteOiProjeto',
          width: '',
        },
      ],
    },
    {
      title: 'RC',
      key: 'rc',
      children: [
        {
          title: 'NÚMERO	',
          dataIndex: 'rcNumero',
          width: '',
        },
        {
          title: 'SEQ',
          dataIndex: 'rcSeq',
          width: '',
        },
        {
          title: 'STATUS',
          dataIndex: 'rcStatus',
          width: '',
        },
      ],
    },
    {
      title: 'OC',
      key: 'oc',
      children: [
        {
          title: 'Numero',
          dataIndex: 'ocNumero',
          width: '',
        },
        {
          title: 'Data',
          dataIndex: 'ocData',
          width: '',
        },
      ],
    }
  ];

  const columsNovasLinhas = [
    {
      title: 'Projeto',
      dataIndex: 'codigo',
      width: '2%',
    },
    {
      title: 'PCT/OI',
      dataIndex: 'codigoPacote',
      width: '5%',
    },
    {
      title: 'No OI',
      dataIndex: 'numero',
      width: '10%',
    },
    {
      title: 'DESCRIÇÃO DO PACOTE',
      dataIndex: 'nome',
    },
  ];

  const deletarLinhaRateio = async (ordemInvestimentoRequisicaoCompraSeqId: string) => {
    const result = await deleteRequisitadoAno(ordemInvestimentoRequisicaoCompraSeqId);
    if (result) {
      if (result.valid) {
        notification.success('Item removido com sucesso.');
        AtualizarTablelaContratoAno();
      } else {
        if (result.invalid) {
          if (result.notifications.length > 0) {
            result.notifications.map(mensagem => {
              const mensagemNotificacao = mensagem as Notifications;
              notification.error(mensagemNotificacao.message);
            })
          }
        }
      }
    }
  };

  const btnsDistribuicaoItem = useMemo(() => {
    const actions = [];

    if (hasPermission(['MODULO_REQUISITADO_ALTERAR_INCLUIR_DELETAR'])) {

      actions.push(
        <ButtonDelete
          type="link"
          confirm="Deseja realmente excluir este registro?"
          title="EXCLUIR LINHA"
          icon="data-delete_row"
          okText="Confirmar"
          className="btn-delete-without-text"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (distribuicaoItemSelecionado && distribuicaoItemSelecionado.ordemInvestimentoRequisicaoCompraSeqId) {
              deletarLinhaRateio(distribuicaoItemSelecionado.ordemInvestimentoRequisicaoCompraSeqId);
            } else {
              notification.error('Você deve selecionar um item');
            }
          }}
        />,
      );
      actions.push(
        <Button
          type="link"
          title="ADICIONAR COLUNA"
          icon="data-add_column"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (resultadoSelecionado) {
              adcionarColunaItemRateavelRequisitadoAno(resultadoSelecionado).then(data => {
                if (data.valid) {
                  AtualizarTablelaContratoAno();
                }
              });
            } else {
              notification.error('Você deve selecionar um item');
            }
          }}
        />,
      );

      actions.push(
        <Button
          type="link"
          title="ADICIONAR LINHA"
          disabled={enableBtnsRateio}
          icon="data-add_row"
          onClick={() => {
            setDisplayWidgetNovaLinha({ display: 'block' });
            setEnableBtnsRateio(true);
          }}
        />,
      );

      actions.push(
        <Button
          type="primary"
          Icon="messaging-ok"
          title="Concluir Rateio"
          disabled={enableBtnsRateio}
          onClick={() => {
            if (resultadoSelecionado) {
              concluirRateioOcRc(resultadoSelecionado).then((data) => {

              });
            }
          }} />);

    }
    return actions;

  }, [resultadoSelecionado, distribuicaoItemSelecionado, enableBtnsRateio]);

  const btnsNovaLinha = useMemo(() => {
    const actions = [];
    actions.push(
      <Button
        type="link"
        title="Cancelar"
        icon="commons-cancel"
        onClick={() => {
          setEnableBtnsRateio(false);
          setProjetoOrdemInvestimento([] as ProjetoOrdemInvestimento[]);
          setDisplayWidgetNovaLinha({ display: 'none' });
        }}
      />,
    );

    actions.push(
      <Button
        type="primary"
        title="Adcionar linha selecionada"
        icon="data-add_row"
        disabled={btnAdcionarLinhaSelecionado}
        onClick={() => {
          if (selectionOrdemInvestimento && resultadoSelecionado) {
            adcionarLinhaItemRateavelRequisitadoAno(selectionOrdemInvestimento.ordemInvestimentoId, resultadoSelecionado).then(
              data => {
                AtualizarTablelaContratoAno();
              },
            );
          } else {
            notification.error('Você deve selecionar uma ORDEM DE INVESTIMENTO');
          }
        }}
      />,
    );

    return actions;
  }, [selectionOrdemInvestimento, resultadoSelecionado, btnAdcionarLinhaSelecionado]);

  const AtualizarTablelaContratoAno = () => {
    getAllRequisitadoAno(resultadoSelecionado).then(data => {
      if (data) {
        const resultContratoAno = data as DistribuicaoRequisitado;
        setDistribuicao(resultContratoAno);
        setResultContratadoAno(resultContratoAno.resultDataTabel);
        if (resultContratoAno.resultDataTabel.length > 0) {
          obterNaratinva(resultContratoAno.resultDataTabel[0].ordemInvestimentoRequisicaoCompraSeqId);
        }
      }
    });
  };

  const obterNaratinva = (ordemInvestimentoRequisicaoCompraSeqId: string) => {
    obterNarativaPorOrdemInvestimentoRequisicaoCompraSeqId(ordemInvestimentoRequisicaoCompraSeqId).then(data => {
      if (data)
        setImputTextoNarativa(data);
    });

  }

  const buscarDistribuicaoItem = () => {
    if (resultadoSelecionado) {
      getAllRequisitadoAno(resultadoSelecionado).then(data => {
        if (data) {
          const resultContratoAno = data as DistribuicaoRequisitado;
          setDistribuicao(resultContratoAno);
          setResultContratadoAno(resultContratoAno.resultDataTabel);
          setDisplayWidgetTabelaDistribuicao({ display: 'block' });
          if (resultContratoAno.resultDataTabel.length > 0) {
            obterNaratinva(resultContratoAno.resultDataTabel[0].ordemInvestimentoRequisicaoCompraSeqId);
          }
        }
      });
    } else {
      notification.error('Você deve selecionar um item');
    }
  };

  const handleChangeImputProjeto = (event: ChangeEvent<HTMLInputElement>) => {
    setImputProjeto(event.target.value);
  };
  const handleChangeImputPacoteOi = (event: ChangeEvent<HTMLInputElement>) => {
    setImputPacoteOi(event.target.value);
  };

  return (
    <SimpleView>
      <GridView noform>
        <FiltrosPcs onSearch={handleFilter} atualizarTela={limparCamposTela} />

        <Widget
          title="RESULTADO"
          span={12}
          style={displayWidgetResultado}
          actions={[
            <Button
              type="primary"
              title="VER DISTRIBUIÇÃO"
              icon="data-database"
              onClick={() => {
                buscarDistribuicaoItem();
              }}
            />,
          ]}>
          <Table
            rowKey="ordemInvestimentoRequisicaoCompraSeqId"
            id={'tabelaDistribuicaoResultRequisitadoOc'}
            columns={columsRequisicaoCompraSeq}
            dataSource={resultPesquisa}
            rowSelection={{
              ...rowSelection,
            }}
          />
        </Widget>



        <Widget
          title="DISTRIBUIÇÃO DO ITEM"
          actions={btnsDistribuicaoItem}
          style={displayWidgetTabelaDistribuicao}>

          <MasterDetailForm initialValues={[]}>
            {/* <FormTextArea
              label="Narrativa"
              name="Narrativa"
              rows={7}
              value={imputTextoNarativa}
              disabled
            /> */}

            <Narativa textoNarativa={imputTextoNarativa} />

          </MasterDetailForm>



          <Table
            id={'tabelaDistribuicaoRequisitadoOc'}
            rowKey="ordemInvestimentoRequisicaoCompraSeqId"
            columns={columsDistribuicaoItem}
            dataSource={resultContratadoAno}
            pagination={false}
            rowSelection={{
              ...rowSelectionTableDistribuicao,
            }}
          />

          <Widget
            title="INSERIR NOVAS LINHAS"
            className="inserir-novo-item"
            span={12}
            actions={btnsNovaLinha}
            style={displayWidgetNovaLinha}>
            <MasterDetailForm initialValues={[]}>
              <FormInput label="Código Projeto" name="projeto" span={2} allowClear onChange={handleChangeImputProjeto} />
              <FormInput label="Código Pacote/OI" name="pacoteOi" span={2} allowClear onChange={handleChangeImputPacoteOi} />
              <Button
                type="link"
                title="PESQUISAR"
                onClick={() => {
                  if (imputProjeto !== '' || imputPacoteOi !== '') {
                    getAllProjetoOrdemInvestimento(imputProjeto, imputPacoteOi).then(data => {
                      setProjetoOrdemInvestimento(data);
                      if (data && data.length > 0) {
                        setBtnAdcionarLinhaSelecionada(false);
                      } else {
                        setBtnAdcionarLinhaSelecionada(true);
                      }
                    });
                  } else {
                    notification.error('Deve ser informado o Projeto ou Pacote/OI');
                  }
                }}
              />
            </MasterDetailForm>

            <Table
              rowKey="ordemInvestimentoId"
              columns={columsNovasLinhas}
              dataSource={resultProjetoOrdemInvestimento}
              rowSelection={{
                ...rowSelectionOrdemInvestimento,
              }}
            />
          </Widget>
        </Widget>
      </GridView>
    </SimpleView>
  );
};

export default RequisitadoOc;
